export const SUPPORTED_LANGUAGES = [ 'en', 'fr', 'nl', 'de', 'es', 'it', 'pl', 'pt', 'pt-PT' ] as const

export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number]

export const isSupportedLanguage = (candidate:string): candidate is SupportedLanguage =>
  (SUPPORTED_LANGUAGES as unknown as string[]).includes(candidate)

export const parse = (language: string): SupportedLanguage|null => isSupportedLanguage(language) ? language : null

export const fromBrowserPreference = ():SupportedLanguage => {
  // read preferred locales
  const preferredLocales = navigator.languages ?? [ navigator.language ?? 'en' ]
  // use the first full locale (ie language variant) supported as language
  for (const locale of preferredLocales){
    console.log(locale)
    if (isSupportedLanguage(locale)){
      return locale
    }
  }
  // if none is, use the first language code (ie default language variant) supported as language
  for (const locale of preferredLocales){
    const languageCode = locale.split('-')[0]
    console.log(languageCode)
    if (isSupportedLanguage(languageCode)) {
      return languageCode
    }
  }
  // if nothing works, use en as fallback
  return 'en'
}

export const toLocalStorage = (language : SupportedLanguage ):void => localStorage.setItem('language', language)

export const fromLocalStorage = ():SupportedLanguage|null => {
  const value = localStorage.getItem('language')
  if (value === null) {
    return  null
  } else if (isSupportedLanguage(value)){
    return value
  } else {
    return null
  }
}

export const resolve = ():SupportedLanguage =>
  fromLocalStorage() ?? fromBrowserPreference()

export const importTranslations = async (language: SupportedLanguage):Promise<any>=>
  import(`../../../assets/i18n/${language}.json`).then(res=>res.default)
